export const sortByValue = <Type>(obj: Type): Type => {
    return Object.fromEntries(
        Object.entries(obj).sort((a, b) => b[1] - a[1])
    ) as Type;
}